import React, { memo } from 'react';
import { FX } from 'shared-modules/constants';
import PropTypes from 'prop-types';
import styles from '../steps.module.scss';

const Step10 = ({ serviceId }) => {
  return (
    <div className={styles.content}>
      <div className={styles.mainContent}>
        <p>
          フォロー値は、買いの場合は決済価格からどのくらい上がったら、次新たに買うかを値幅
          {serviceId === FX && '（pips）'}
          で設定する、再エントリーの条件になります。売りの場合は反対で、決済価格からどのくらい下がったらまた売るかを設定します。
        </p>
      </div>
    </div>
  );
};

Step10.propTypes = {
  serviceId: PropTypes.string,
};

Step10.defaultProps = {
  serviceId: '',
};

export default memo(Step10);
